import { memo } from 'react'
import { Stack, Typography } from '@mui/material'
import EmptyBox from '../../assets/icons/EmptyBox'
import RefreshIcon from '../../assets/icons/RefreshIcon'


type Props = {
    text: string
}
const ReconnectView = (props: Props) => {

    return (
        <Stack direction={'column'} alignItems={'center'} spacing={2}>
            <RefreshIcon sx={{ color: 'text.secondary' }} width={120} height={120}/>
            <Typography color="textSecondary" sx={{ textAlign: 'center' }} variant={'body1'} >
                {props.text}
            </Typography>
        </Stack>
    )
}

export default memo(ReconnectView)